// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type Currency =
  | 'ADA'
  | 'ARS'
  | 'AUD'
  | 'BDT'
  | 'BNB'
  | 'BOB'
  | 'BRL'
  | 'BTC'
  | 'BUSD'
  | 'CAD'
  | 'CLP'
  | 'CNY'
  | 'CRC'
  | 'DAI'
  | 'DOGE'
  | 'ETH'
  | 'EUR'
  | 'GEL'
  | 'HKD'
  | 'IDR'
  | 'INR'
  | 'IQD'
  | 'JPY'
  | 'KRW'
  | 'LTC'
  | 'MATIC'
  | 'MXN'
  | 'MYR'
  | 'PEN'
  | 'PKR'
  | 'RUB'
  | 'SHIB'
  | 'SOC'
  | 'SOL'
  | 'THB'
  | 'TON'
  | 'TRX'
  | 'TRY'
  | 'UAH'
  | 'USD'
  | 'USDC'
  | 'USDT'
  | 'VES'
  | 'VND'
  | 'XRP';

export type SportsbetPreferencesUpdateCurrencyInput = {
  clientMutationId?: string | null | undefined;
  currency: Currency;
  id: any;
};

export type UpdateSbCurrencyMutationVariables = Exact<{
  input: Types.SportsbetPreferencesUpdateCurrencyInput;
}>;


export type UpdateSbCurrencyMutation = { sportsbetPreferencesUpdateCurrency: { userPreferences: { id: string, currency: Types.Currency } | undefined } | undefined };


export const UpdateSbCurrencyMutationDocument = gql`
    mutation UpdateSbCurrencyMutation($input: SportsbetPreferencesUpdateCurrencyInput!) {
  sportsbetPreferencesUpdateCurrency(input: $input) {
    userPreferences {
      id
      currency
    }
  }
}
    `;